import PropTypes from 'prop-types';
import React from 'react';
import ReceiptTax from 'components/receipt/commons/CountingBox/ReceiptTax';
import Subtotal from 'components/receipt/commons/CountingBox/Subtotal';
import Gratuity from 'components/receipt/commons/CountingBox/Gratuity';
import Rounding from 'components/receipt/commons/CountingBox/Rounding';
import styles from './CountingBox.css';

class ReceiptCountingBox extends React.Component {
  render() {
    const { invoiceDetail } = this.props;
    return (
      <div className={styles['receipt-counting-box']}>
        <Subtotal subtotal={invoiceDetail.subtotal} />
        {invoiceDetail.payment_gratuities.length > 0 && (
          <Gratuity
            gratuities={invoiceDetail.payment_gratuities}
            includeGratuityTax={invoiceDetail.include_gratuity_tax}
          />
        )}
        {invoiceDetail.payment_taxes.length > 0 && (
          <ReceiptTax
            taxes={invoiceDetail.payment_taxes}
            includeGratuityTax={invoiceDetail.include_gratuity_tax}
          />
        )}
        {Boolean(parseInt(invoiceDetail.total_rounding_amount)) && (
          <Rounding totalRoundingAmount={invoiceDetail.total_rounding_amount} />
        )}
      </div>
    );
  }
}

ReceiptCountingBox.propTypes = {
  invoiceDetail: PropTypes.object,
};

export default ReceiptCountingBox;
